import API, { APIResponse } from '../../../lib/commons/api'
import { IItemDelta } from '../../../domain/value-object/ItemDeltaInputVO'

// テナント設定画面が参照する項目のみを宣言した、バックエンド
// OrganizationDetailDto の部分集合。
export type TenantDetailDto = {
  uuid: string
  // エイリアスは更新APIに項目が無いため表示専用。
  alias: string
  displayName: string
  officialName?: string
  iconUrl?: string
  emailDomainWhitelist?: string
  skipEmailVerification: boolean
  defaultTimezoneId?: string
  dailyWorkHours?: number
  monthlyWorkDays?: number
  financialYearEndMonth?: string
  restrictTaskActualWorkByProjectPeriod: boolean
}

// 更新可能な項目はバックエンドの UpdateOrganizationDelta.Input に合わせる
// （Input が宣言していない alias・maintenanceMessage は送っても捨てられる）。
export type TenantUpdateDeltaInput = {
  uuid: string
  displayName?: IItemDelta<string>
  officialName?: IItemDelta<string>
  iconUrl?: IItemDelta<string>
  emailDomainWhitelist?: IItemDelta<string>
  skipEmailVerification?: IItemDelta<boolean>
  defaultTimezoneId?: IItemDelta<string>
  dailyWorkHours?: IItemDelta<number>
  monthlyWorkDays?: IItemDelta<number>
  financialYearEndMonth?: IItemDelta<string>
  restrictTaskActualWorkByProjectPeriod?: IItemDelta<boolean>
}

// 接続失敗時、api.tsのfetchラッパーは通知を出したうえで空の成功応答（json: {}）を
// 返す。空のテナントとして扱わず、かつ通知を重ねないよう、例外ではなく undefined を返す。
export const fetchTenantDetail = async (
  tenantUuid: string
): Promise<TenantDetailDto | undefined> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/tenants/detail',
    { tenantUuid }
  )
  if (!response.json?.uuid) return undefined
  return response.json as TenantDetailDto
}

// 更新は 200 レスポンスにワーニング・エラーメッセージが含まれることがあるため、
// 呼び出し元で判定できるようレスポンスをそのまま返す。接続失敗時は取得と同じ理由で
// undefined を返す。
export const updateTenantDelta = async (
  input: TenantUpdateDeltaInput
): Promise<APIResponse | undefined> => {
  const response = await API.functional.request(
    'PUT',
    '/api/v1/tenants/delta',
    input
  )
  if (!response.hasWarning && !response.hasError && !response.json?.uuid) {
    return undefined
  }
  return response
}
